import { useEffect, useState } from "react";
import Subscribe from "../APIController/Subscribe";
import Text from "./Text";
import Button from "./Buttons/Button";

const SubscriptionInfo = ({ subscribable = true, direction ="flex md:flex-row flex-col gap-4 w-full justify-center" }) => {
    const { subscribeToPlan, getPlans } = Subscribe();
    const [plans, setPlans] = useState([])

    const handleSubscribe = async (planIndex) => {
        if (subscribable) {
            try {
                const response = await subscribeToPlan({ plan: planIndex });

                if (response?.checkoutUrl) {
                    window.location.href = response.checkoutUrl;
                } else {
                    console.error("No checkout url returned");
                }
            } catch (err) {
                console.error("Subscription error", err);
            }
        }

    };

    useEffect(() => {
        handlePlanFetch()
    }, [])

    async function handlePlanFetch() {
        const data = await getPlans()
        setPlans(data.sort((a, b) => a.price - b.price))
    }

    const SubscriptionCard = ({ subscription, index }) => (
        <div className="flex bg-white flex-col border-2 rounded-lg gap-4 p-4 hover:border-blue-500 transition-colors shadow-md hover:shadow-lg">
            <div className="flex flex-col gap-2">
                <Text type="subtitle" classNames="text-center">
                    {subscription.name}
                </Text>
                <Text type="maintitle" classNames="text-center text-blue-600">
                    {subscription.price} CHF
                </Text>
                <Text type="itemtext" classNames="text-center min-h-[40px]">
                    {subscription.description}
                </Text>
            </div>
            <div className="flex flex-col gap-2 pt-2 border-t">
                <Text type="itemtext" classNames="text-center min-h-[40px]">
                    Für Features und Vergleiche siehe Tabelle
                </Text>
            </div>

            {subscribable && (
                <Button
                    buttonColor="bg-blue-600 hover:bg-blue-700 text-white"
                    text="Auswählen"
                    onClickAction={() => handleSubscribe(subscription.id)}
                />
            )}

        </div>
    );

    return (
        <div className={direction}>
            {plans && plans.map((sub, index) => (
                <SubscriptionCard
                    key={index}
                    subscription={sub}
                    index={index}

                />
            ))}
        </div>
    )

}
export default SubscriptionInfo